import { NgModule, ModuleWithProviders } from "@angular/core";

import { MedicalIconPipe } from "./medical-icon.pipe";
import { MedicalIconColorPipe } from "./medical-icon-color.pipe";
import { MedicalIconService } from "./medical-icon.service";

@NgModule({
	declarations: [MedicalIconPipe, MedicalIconColorPipe],
	exports: [MedicalIconPipe, MedicalIconColorPipe],
})
export class MedicalIconModule {
	static forRoot(): ModuleWithProviders<MedicalIconModule> {
		return {
			ngModule: MedicalIconModule,
			providers: [MedicalIconService],
		};
	}
}
